import { palette, typography } from '@src/core/styles';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const HeaderWrapper = styled.header`
  border-bottom: ${palette.border.grey};
`;

export const StyledHeader = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LoginLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  ${typography.label_large};
  color: ${palette.colors.green_base};
`;
